import styled from "styled-components";
import { Card } from "../../components/Card";
import colors from "@styling/colors";
import { borderRadius, spacing } from "@styling/sizing";
import { fontSizes } from "@styling/fonts";

export type StatusTone = "good" | "muted" | "warning" | "bad";

const toneBackground: Record<StatusTone, string> = {
  good: colors.successBackground,
  muted: colors.backgroundDark,
  warning: colors.warningBackground,
  bad: colors.dangerBackground,
};

const toneText: Record<StatusTone, string> = {
  good: colors.successText,
  muted: colors.textMuted,
  warning: colors.warning,
  bad: colors.dangerText,
};

export const SettingsSection = styled(Card)`
  max-width: 820px;
  display: flex;
  flex-direction: column;
  gap: ${spacing.x2}px;
`;

export const SettingsMuted = styled.p`
  margin: 0;
  color: ${colors.textMuted};
  font-size: ${fontSizes.medium}px;
`;

export const SettingsField = styled.label`
  display: flex;
  flex-direction: column;
  gap: ${spacing.x1}px;
  font-size: ${fontSizes.medium}px;
  font-weight: 600;
`;

export const SettingsFieldset = styled.fieldset`
  display: flex;
  flex-wrap: wrap;
  gap: ${spacing.x2}px;
  margin: 0;
  padding: 0;
  border: none;

  legend {
    font-size: ${fontSizes.medium}px;
    font-weight: 600;
    margin-bottom: ${spacing.x1}px;
  }
`;

export const SettingsChoice = styled.label`
  display: flex;
  align-items: center;
  gap: ${spacing.x1}px;
  cursor: pointer;
`;

export const SettingsActions = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: ${spacing.x1}px;
  align-items: flex-start;
`;

export const StatusBadge = styled.span<{ $tone: StatusTone }>`
  margin-left: ${spacing.x1}px;
  font-size: ${fontSizes.small}px;
  font-weight: 600;
  padding: 2px ${spacing.x1}px;
  border-radius: ${borderRadius.small}px;
  background: ${({ $tone }) => toneBackground[$tone]};
  color: ${({ $tone }) => toneText[$tone]};
`;
